import React, { useEffect, useState } from 'react';

import { useThrottledToast } from '../../hooks/useThrottledToast';

import { Switch, Modal, ImageZoomModal, PageHeader } from '../../shared/ui';
import mockMackCard8 from '../../assets/images/mac-cards/mac-card-8-full.png';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { selectMetaforicCards } from '../../store/psyTools.slice';
import { baseUrl } from '../../configs/api/api.config';
import { selectUser, setUserData } from '../../store/auth.slice';
import { useChangeUserMutation } from '../../services/users.api';
import { useTariffToolCheck } from '../../hooks/useTariffToolCheck';

const makeUrl = (url: string) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `${baseUrl}${url}`;
};

const MetaphoricalCards = () => {
  const tool = 'metaforic_cards';
  const isActiveByTariff = useTariffToolCheck(tool);
  const dispatch = useAppDispatch();
  const userData = useAppSelector(selectUser);
  const metaforicCards = useAppSelector(selectMetaforicCards);
  const [changeUser] = useChangeUserMutation();
  const showToast = useThrottledToast();
  const [cards, setCards] = useState<string[] | null>(null);
  const [cardsName, setCardsName] = useState<string>('');
  const [card, setCard] = useState<string | null>(null);

  useEffect(() => {
    if (cards) {
      document.body.classList.add('hidden_scroll');
    }
    if (!cards) {
      document.body.classList.remove('hidden_scroll');
    }
  }, [cards]);

  const handleCheck = async () => {
    if (!isActiveByTariff) return;
    if (!userData) return;
    try {
      if (userData?.active_psy_tools?.includes(tool)) {
        const arr = userData?.active_psy_tools.filter((el) => el !== tool);
        dispatch(setUserData({ ...userData, active_psy_tools: arr }));
        await changeUser({
          id: userData.id,
          active_psy_tools: arr,
        });
      } else {
        dispatch(
          setUserData({
            ...userData,
            active_psy_tools: [...userData?.active_psy_tools, tool],
          }),
        );
        await changeUser({
          id: userData.id,
          active_psy_tools: [...userData?.active_psy_tools, tool],
        });
      }
      showToast('success');
    } catch (error) {
      showToast('error');
    }
  };

  return (
    <div className="pb-[80px]">
      <PageHeader backTo="/tools" title="Метафорические карты – дверь в подсознание" />
      <p className="text-ui text-ink-muted mb-5">
        В видео сервис встроены колоды для диагностики и психотерапии. ZiNGiZi запишет в терапевтический журнал, какие
        карты помогли мягко преодолеть сопротивление и оказали трансформационный эффект.
      </p>

      <div className="flex items-center gap-5 mb-[40px]">
        <Switch
          checked={userData?.active_psy_tools?.includes(tool)}
          disabled={!isActiveByTariff}
          onChange={() => handleCheck()}
          label={'Использовать Мак-карты в видео-сессиях'}
        />
      </div>

      <div className="flex flex-wrap gap-[26px]">
        {metaforicCards &&
          metaforicCards.psy_tool_settings
            .filter((card) => !card.value[0].includes('Релиз'))
            .map((card) => (
              <div
                key={card.id}
                className="w-[150px] md:cursor-pointer"
                onClick={() => {
                  setCards(card.value);
                  setCardsName(card.name);
                }}
              >
                <div className="w-[150px] h-[180px] mb-[15px]">
                  <img src={makeUrl(card.value[0])} alt="" className="w-full h-full object-cover rounded-control" />
                </div>
                <p className="text-ui text-ink-muted text-center">{card.name}</p>
              </div>
            ))}
        {metaforicCards &&
          metaforicCards.psy_tool_settings
            .filter((card) => card.value[0].toLowerCase().includes('релиз'))
            .map((card) => (
              <div key={card.id} className="w-[150px]">
                <div className="w-[150px] h-[180px] mb-[15px] relative">
                  <div className="absolute top-0 left-0 w-full h-full z-3 bg-black/40 rounded-control"></div>
                  <div className="absolute top-0 right-0 z-1 text-ink text-ui-xs-strong rounded-chip p-[5px_15px] bg-accent">
                    {card.value[0]}
                  </div>
                  <img src={mockMackCard8} alt="" className="w-full h-full object-cover rounded-control" />
                </div>
                <p className="text-ui text-ink-muted text-center">{card.name}</p>
              </div>
            ))}
      </div>

      <Modal
        isOpen={Boolean(cards)}
        size="xl"
        title={`Колода “${cardsName}”`}
        onClose={() => {
          setCards(null);
          setCardsName('');
        }}
      >
        <div className="flex flex-wrap gap-[40px]">
          {cards?.map((card, i) => (
            <div
              key={i}
              className="w-[120px] md:w-[140px] h-[160px] md:h-[180px] md:cursor-pointer"
              onClick={() => setCard(card)}
            >
              <img src={makeUrl(card)} alt="" className="w-full h-full object-cover rounded-control" />
            </div>
          ))}
        </div>
      </Modal>

      {card && <ImageZoomModal src={makeUrl(card)} onClose={() => setCard(null)} />}
    </div>
  );
};

export default MetaphoricalCards;
